module.exports = __webpack_public_path__ + "img/top-10-thumb.77748400.jpg";